// ============================================================================
// AVATAR KNOWLEDGE BASE UTILS
// Shared helpers for avatar knowledge base document display (file type,
// dates, test status styling)
// ============================================================================

import type { AvatarKBTestResponse } from '../hooks/useAvatarKB';

export function getFileExtension(fileName: string): string {
  return fileName.split('.').pop()?.toLowerCase() || '';
}

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function testStatusBadgeClass(status: AvatarKBTestResponse['status']): string {
  switch (status) {
    case 'passed': return 'bg-green-50 text-green-700 border-green-200';
    case 'partial': return 'bg-amber-50 text-amber-700 border-amber-200';
    case 'failed': return 'bg-red-50 text-red-700 border-red-200';
    default: return 'bg-slate-50 text-slate-500 border-slate-200';
  }
}
